module.exports = __webpack_public_path__ + "img/alert.1d7c52f9.svg";